import * as React from 'react';
import { MoreHorizontal } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from 'components/ui/dropdown-menu';
import { Button } from 'components/ui/button';

export type MenuAction = {
  label: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

type Props = {
  menuActions: MenuAction[];
}

export const ActionsMenu = ({ menuActions }: Props) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        asChild
        onClick={event => event.stopPropagation()}
      >
        <Button variant="ghost" className="ml-auto h-8 w-8 p-0">
          <MoreHorizontal className="h-5 w-5 text-slate-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={'end'}
        className="bg-white"
        onClick={event => event.stopPropagation()}
      >
        {menuActions.map((action, index) => (
          <DropdownMenuItem
            key={index}
            disabled={action.disabled}
            onClick={action.onClick}
          >
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
